import { Link, Stack, useLocalSearchParams, useRouter } from 'expo-router';
import { useQuery } from 'urql';
import FadeInContent from '@/components/Animation/FadeInContent';
import Box from '@/components/UI/Box';
import Button from '@/components/UI/Button';
import Card from '@/components/UI/Card';
import Text from '@/components/UI/Text';
import { graphql } from '@/gql/graphql';
import useHeaderButton from '@/hooks/useHeaderButton';
import useResetHistory from '@/hooks/useResetHistory';

const GetEventGenerateDone = graphql(/* GraphQL */ `
  query GetEventGenerateDone($eventId: uuid!) {
    event_by_pk(id: $eventId) {
      id
      title
      parent_id
    }
  }
`);

export default function EventGenerateDone() {
  useResetHistory();
  const { dismissTo, dismiss } = useRouter();

  const { eventId } = useLocalSearchParams<{
    eventId?: string;
  }>();

  const [{ data, fetching }] = useQuery({
    query: GetEventGenerateDone,
    variables: {
      eventId: eventId!,
    },
  });

  const event = data?.event_by_pk;

  const headerRight = useHeaderButton(
    () => {
      dismiss();
    },
    'Done',
    false,
    'success',
  );

  return (
    <FadeInContent fetching={fetching}>
      <Stack.Screen
        options={{
          title: event?.title || '',
          headerRight,
        }}
      />
      <Box direction="vertical" space="sm" mx="md">
        <Card p="lg">
          <Box direction="vertical" space="md">
            <Box direction="vertical" align="center" space="xs">
              <Text size="2xl" center>
                🎉 Awesome! You just generated games for
              </Text>
              <Text size="2xl" variant="primary" center>
                {event?.title}
              </Text>
              <Text center>What would you like to do next?</Text>
            </Box>
            <Box direction="horizontal" justify="center" space="sm" wrap>
              <Button
                onPress={() => {
                  setTimeout(() => {
                    dismissTo({
                      pathname: '/event/create',
                      params: {
                        parentId: event?.parent_id,
                        eventType: 'group',
                      },
                    });
                  }, 0);
                }}
                size="sm"
                appearance="outline"
                variant="positive"
                testID="EventGenerateDoneSeasonButton"
              >
                <Button.Text numberOfLines={1}>
                  Create Another Season
                </Button.Text>
              </Button>
              <Link
                dismissTo
                href={{
                  pathname: '/organization/schedule/[eventId]',
                  params: { eventId: data?.event_by_pk?.id },
                }}
                asChild
              >
                <Button
                  testID="EventGenerateDoneGoToButton"
                  size="sm"
                  appearance="outline"
                  variant="primary"
                >
                  <Button.Text>Go To {event?.title}</Button.Text>
                </Button>
              </Link>
            </Box>
          </Box>
        </Card>
      </Box>
    </FadeInContent>
  );
}
